(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tribe-product-images"] && !Shopify.designMode) return;
  try {
    let swiper;
  const selector = '.product-gallery__swiper';
  const mq = window.matchMedia('(max-width: 1023px)');

  const initSwiper = () => {
    if (mq.matches) {
      if (!swiper) {
        swiper = new Swiper(selector, {
          speed: 1000,
          rewind: true,
          // autoplay: { delay: 5000, disableOnInteraction: false },
          slidesPerView: 1.115,
          centeredSlides: true,
          spaceBetween: 12,
        });
      }
    } else {
      swiper?.destroy(true, true);
      swiper = null;
    }

    // Swap images are only clickable on desktop; on mobile the carousel takes over
    document.querySelectorAll('[data-gallery-swap]').forEach((img) => {
      if (mq.matches) {
        img.removeAttribute('tabindex');
        img.removeAttribute('role');
      } else {
        img.setAttribute('tabindex', '0');
        img.setAttribute('role', 'button');
      }
    });
  };

  // Trade the clicked image with the primary so no image is lost from the gallery.
  // Each slot keeps its own `sizes`, so the browser still picks the right resolution.
  const swapWithPrimary = (thumb) => {
    const primary = document.querySelector('.product-img--primary .product-gallery__img');
    if (!primary || mq.matches) return;

    ['src', 'srcset', 'alt', 'width', 'height'].forEach((attr) => {
      const primaryValue = primary.getAttribute(attr);
      primary.setAttribute(attr, thumb.getAttribute(attr));
      thumb.setAttribute(attr, primaryValue);
    });
  };

  const gallery = document.querySelector('.product-gallery');
  gallery?.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-swap]');
    if (thumb) swapWithPrimary(thumb);
  });
  gallery?.addEventListener('keydown', (e) => {
    const thumb = e.target.closest('[data-gallery-swap]');
    if (thumb && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      swapWithPrimary(thumb);
    }
  });

  initSwiper();
  mq.addEventListener('change', initSwiper);
  } catch(e) { console.error(e); }
})();

})();
